// extracted by mini-css-extract-plugin
export default {"nameContainer":"nameContainer---LzLhQ","pronouns":"pronouns---HWJgN"};